import { Component, Injector, OnInit, ViewChild, HostListener } from '@angular/core';
import { RecaptchaComponent, RecaptchaErrorParameters } from 'ng-recaptcha';
import { Color } from 'src/app/config/color';
import { SecurityDataService } from 'src/app/submodules/angular-common/security-data.service';
import { ApiErrorPayload } from 'submodules/engine-common/api-error-payload';
import { FormSettings } from '../../../forms/form-settings';
import { PageFormComponent } from '../../../forms/page-form.component';
import { NotificationDataService } from '../../../notification-data.service';
import { TranslateService } from '@ngx-translate/core';
import { RoutingDataService } from 'src/app/submodules/angular-common/routing-data.service';
import { Router } from '@angular/router';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { SignUpStep1Service } from './sign-up-step1.service';
import * as pkg from '../../../../../../../package.json';
import { isClassPresentInDomEventTarget, navigateToSamePage } from 'src/app/submodules/angular-common/util';

@Component({
  selector: 'app-sign-up-step1',
  templateUrl: './sign-up-step1.component.html',
  styleUrls: ['./sign-up-step1.component.scss'],
  providers:  [ SignUpStep1Service ]
})
export class SignUpStep1Component extends PageFormComponent {

  public this = this;

  public bgColor = Color.auxiliary;
  public requireRecaptcha: boolean = true; 
  public recaptchaToken;
  public emailAsUsername;

  public submitDone:boolean = false; //true se effettuato almeno un submit e quindi viene mostrato il messaggio di feedback

  constructor(protected _injector: Injector) { 
    super(_injector);
  }

  async ngOnInit() {
    await super.init();
    this.emailAsUsername = this._injector.get(EnvironmentDataService).environment.getValue("emailAsUsername");
  }

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(isClassPresentInDomEventTarget(event, 'retry'))  
      this.retry()
  }
  
  @ViewChild('reCaptcha', {static: false}) reCaptcha: RecaptchaComponent;

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        firstName: { required: true },
        lastName: { required: true },
        email: { required: true, allowBlanks: false }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {}
  }
  
  /** @override */
  protected async _submitHook() {

    try {
      await this._injector.get(SignUpStep1Service).requireSignUp(
        this.currentValues.firstName?this.currentValues.firstName as string:undefined,
        this.currentValues.lastName?this.currentValues.lastName as string:undefined,
        this.currentValues.email as string,
        pkg.name.replace(pkg.group+'-',''),
        this.recaptchaToken);

        this.submitDone = true;
      
    } catch (error) {
      if(this.reCaptcha)
        this.reCaptcha.reset()
      
      const errorPayload: ApiErrorPayload = error.error;
      if(errorPayload.status==403 && errorPayload.errorCode == "AUTH.RECAPTCHA_TOKEN_REQUIRED"){
        this.requireRecaptcha = true;
      }
      throw error;
    }
  }

  public onError(errorDetails: RecaptchaErrorParameters): void {
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }

  async cancel(){
    this._injector.get(Router).navigate(["/login"])
  }

  retry(){
    //triangolare per ricaricare la pagina
    navigateToSamePage(this._injector, 'sign-up')
  }
}
